<template>
    <!--eslint-disable max-len-->
    <div class="qy-wechat">
        <div class="qy-wechat-aside">
            <svg
                width="40"
                height="370"
                viewBox="0 0 40 370"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    width="40"
                    height="370"
                    fill="#366CB3"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M27.5 149.5H12.5V146.5H27.5V149.5ZM12.5 150H27.5V159.5H12.5V150ZM12 149.5V150V159.5V160H12.5H27.5H28V159.5V150V149.5V146.5V146H27.5H12.5H12V146.5V149.5ZM16 152.5H15.5V153V153.5V154H16H16.5H17V153.5V153V152.5H16.5H16ZM16 155.5H15.5V156V156.5V157H16H16.5H17V156.5V156V155.5H16.5H16ZM19.5 152.5H20H20.5H21V153V153.5V154H20.5H20H19.5V153.5V153V152.5ZM20 155.5H19.5V156V156.5V157H20H20.5H21V156.5V156V155.5H20.5H20ZM23.5 152.5H24H24.5H25V153V153.5V154H24.5H24H23.5V153.5V153V152.5ZM24 155.5H23.5V156V156.5V157H24H24.5H25V156.5V156V155.5H24.5H24Z"
                    fill="#D7E2F0"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.5 183.5H18.5V188.5H13.5V183.5ZM13 183H13.5H18.5H19V183.5V188.5V189H18.5H13.5H13V188.5V183.5V183ZM13.5 191.5H18.5V196.5H13.5V191.5ZM13 191H13.5H18.5H19V191.5V196.5V197H18.5H13.5H13V196.5V191.5V191ZM26.5 183.5H21.5V188.5H26.5V183.5ZM21.5 183H21V183.5V188.5V189H21.5H26.5H27V188.5V183.5V183H26.5H21.5ZM21.5 191.5H26.5V196.5H21.5V191.5ZM21 191H21.5H26.5H27V191.5V196.5V197H26.5H21.5H21V196.5V191.5V191Z"
                    fill="#D7E2F0"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.5 111H18.5V114H21.5V111ZM18.5 110.5H18V111V114V114.5H18.5H21.5H22V114V111V110.5H21.5H18.5ZM21.5 119.5H18.5V122.5H21.5V119.5ZM18.5 119H18V119.5V122.5V123H18.5H21.5H22V122.5V119.5V119H21.5H18.5ZM12.5 122.5V119.5H15.5V122.5H12.5ZM12 119H12.5H14V117V116.5H26V117V119H27.5H28V119.5V122.5V123H27.5H24.5H24V122.5V119.5V119H24.5H25.5V117H14.5V119H15.5H16V119.5V122.5V123H15.5H12.5H12V122.5V119.5V119ZM27.5 122.5V119.5H24.5V122.5H27.5Z"
                    fill="#D7E2F0"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.5 325.5H24.5V334.5H13.5V325.5ZM13 325H13.5H24.5H25V325.5V334.5V335H24.5H13.5H13V334.5V325.5V325ZM20 328H19.5V328.5H20V328ZM19.5 327.5H19V328H15.5V328.5H19V329H19.5H20H20.5V328.5H22.5V328H20.5V327.5H20H19.5ZM20 331.5H19.5V332H20V331.5ZM19.5 331H19V331.5H15.5V332H19V332.5H19.5H20H20.5V332H22.5V331.5H20.5V331H20H19.5Z"
                    fill="#B9CCE4"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.5 349H13V349.5H13.5H24.5H25V349H24.5H13.5ZM13.5 353.5H13V354H13.5H24.5H25V353.5H24.5H13.5ZM13 358H13.5H24.5H25V358.5H24.5H13.5H13V358Z"
                    fill="#B9CCE4"
                />
                <mask
                    id="mask0"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="8"
                    y="22"
                    width="24"
                    height="24"
                >
                    <path
                        d="M20 46C26.6274 46 32 40.6274 32 34C32 27.3726 26.6274 22 20 22C13.3726 22 8 27.3726 8 34C8 40.6274 13.3726 46 20 46Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask0)">
                    <path
                        d="M20 46C26.6274 46 32 40.6274 32 34C32 27.3726 26.6274 22 20 22C13.3726 22 8 27.3726 8 34C8 40.6274 13.3726 46 20 46Z"
                        fill="#ABBCDF"
                    />
                    <path
                        d="M20.0002 35.8891C22.148 35.8891 23.8891 34.148 23.8891 32.0002C23.8891 29.8524 22.148 28.1113 20.0002 28.1113C17.8524 28.1113 16.1113 29.8524 16.1113 32.0002C16.1113 34.148 17.8524 35.8891 20.0002 35.8891Z"
                        fill="#EAF2FC"
                    />
                    <path
                        d="M20 57C25.5228 57 30 52.5228 30 47C30 41.4772 25.5228 37 20 37C14.4772 37 10 41.4772 10 47C10 52.5228 14.4772 57 20 57Z"
                        fill="#EAF2FC"
                    />
                </g>
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M27.5 80.5C27.5 84.0899 24.1421 87 20 87C18.5968 87 17.2837 86.6661 16.1606 86.0849L13.1328 86.8418C12.8841 86.904 12.6771 86.6458 12.7917 86.4166L13.8743 84.2513C13.0087 83.1915 12.5 81.8973 12.5 80.5C12.5 76.9101 15.8579 74 20 74C24.1421 74 27.5 76.9101 27.5 80.5Z"
                    fill="white"
                />
            </svg>
        </div>
        <div class="qy-wechat-main">
            <div class="qy-wechat-main-search">
                <svg
                    width="200"
                    height="50"
                    viewBox="0 0 200 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        width="200"
                        height="50"
                        fill="#E6E8EB"
                    />
                    <rect
                        x="10"
                        y="23"
                        width="156"
                        height="20"
                        fill="#D6D8DB"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M182.533 32.5333V26H183.467V32.5333H190V33.4667H183.467V40H182.533V33.4667H176V32.5333H182.533Z"
                        fill="#656C73"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M27.0735 31.9534C27.0735 33.6766 25.6766 35.0735 23.9534 35.0735C22.2302 35.0735 20.8333 33.6766 20.8333 31.9534C20.8333 30.2302 22.2302 28.8333 23.9534 28.8333C25.6766 28.8333 27.0735 30.2302 27.0735 31.9534ZM26.4832 34.9915C25.7977 35.563 24.9157 35.9068 23.9534 35.9068C21.77 35.9068 20 34.1368 20 31.9534C20 29.77 21.77 28 23.9534 28C26.1368 28 27.9068 29.77 27.9068 31.9534C27.9068 32.9157 27.563 33.7977 26.9915 34.4833L29.8947 37.3865C30.0351 37.5268 30.0351 37.7544 29.8947 37.8947C29.7543 38.0351 29.5268 38.0351 29.3864 37.8947L26.4832 34.9915Z"
                        fill="#6B7179"
                    />
                    <path
                        d="M40.53 31.63H41.62V31.03H40.53V30.07C41.01 29.89 41.43 29.71 41.77 29.53L41.36 29C40.89 29.28 40.39 29.49 39.87 29.63V33.24H42.16V34.12H39.81V34.77H40.23C40.61 35.47 41.15 36.08 41.87 36.59C41.12 36.91 40.22 37.17 39.18 37.37L39.54 38.01C40.71 37.75 41.71 37.41 42.55 37.01C43.32 37.43 44.25 37.76 45.34 37.99L45.6 37.32C44.72 37.14 43.95 36.9 43.29 36.6C44.11 36.08 44.71 35.46 45.07 34.73V34.12H42.83V33.24H45.1V29.32H43.35V29.94H44.45V31.03H43.4V31.63H44.45V32.62H42.83V28.87H42.16V32.62H40.53V31.63ZM40.97 34.77H44.29C43.91 35.33 43.34 35.82 42.59 36.24C41.9 35.83 41.36 35.34 40.97 34.77ZM37.65 37.91C38.19 37.91 38.47 37.62 38.47 37.05V34.15C38.81 33.99 39.15 33.83 39.48 33.66V32.96C39.15 33.14 38.81 33.31 38.47 33.46V31.44H39.4V30.75H38.47V28.88H37.77V30.75H36.66V31.44H37.77V33.74C37.35 33.9 36.92 34.03 36.48 34.15L36.64 34.83C37.02 34.71 37.39 34.58 37.77 34.44V36.87C37.77 37.14 37.64 37.28 37.4 37.28C37.14 37.28 36.86 37.26 36.56 37.23L36.71 37.91H37.65ZM47.26 29.62V30.28H50.63V31.15H46.85V32.97H47.55V31.78H50.53C49.95 32.28 49.33 32.72 48.68 33.09C48.53 33.17 48.38 33.23 48.23 33.26L48.37 33.81C49.24 33.79 50.01 33.76 50.69 33.74C49.81 34.24 48.97 34.6 48.15 34.83C47.95 34.83 47.74 34.82 47.53 34.81L47.67 35.46C48.59 35.44 49.6 35.4 50.7 35.35V37.06C50.7 37.26 50.58 37.37 50.36 37.37C50.1 37.37 49.82 37.35 49.54 37.32L49.69 37.99H50.6C51.14 37.99 51.42 37.73 51.42 37.23V35.32C52.14 35.28 52.9 35.23 53.71 35.18C53.91 35.42 54.09 35.66 54.25 35.9L54.79 35.51C54.4 34.97 53.84 34.35 53.11 33.64L52.59 33.97C52.83 34.21 53.06 34.44 53.28 34.68C51.98 34.77 50.69 34.84 49.39 34.88C50.75 34.4 52.01 33.73 53.19 32.85L52.61 32.46C52.25 32.72 51.89 32.97 51.54 33.21C50.98 33.25 50.23 33.27 49.31 33.29C49.96 32.94 50.58 32.53 51.18 32.05L50.63 31.78H54.45V32.98H55.15V31.15H51.37V30.28H54.74V29.62H51.37V28.83H50.63V29.62H47.26ZM52.48 35.85L52.12 36.38C53.08 36.73 54.02 37.21 54.94 37.81L55.31 37.23C54.46 36.69 53.52 36.23 52.48 35.85ZM49.33 35.83C48.62 36.37 47.72 36.81 46.63 37.14L46.93 37.78C48.06 37.39 49 36.9 49.75 36.3L49.33 35.83Z"
                        fill="#656C73"
                    />
                </svg>
            </div>
            <div class="qy-wechat-main-friend">
                <svg
                    width="200"
                    height="50"
                    viewBox="0 0 200 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        width="200"
                        height="50"
                        fill="#D7D9DB"
                    />
                    <text
                        x="52"
                        y="30"
                        fill="#000"
                    >{{ config.app_name }}</text>
                    <image
                        width="32"
                        height="32"
                        x="10"
                        y="9"
                        :xlink:href="getIcon(config.avatar)"
                        @error="iserror = true"
                    />
                </svg>
            </div>
            <div class="qy-wechat-main-foot">
                <svg
                    width="200"
                    height="270"
                    viewBox="0 0 200 270"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        width="200"
                        height="270"
                        fill="#E6E8EB"
                    />
                </svg>
            </div>
        </div>
        <div class="qy-wechat-right">
            <div class="qy-wechat-right-head">
                <svg
                    width="63"
                    height="13"
                    viewBox="0 0 63 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        x="26.5"
                        y="3.5"
                        width="7"
                        height="6"
                        stroke="#6E7882"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M56.4999 5.79252L59.3283 2.96409L60.0355 3.6712L57.207 6.49962L60.0355 9.32813L59.3284 10.0352L56.4999 7.20673L53.6715 10.0352L52.9644 9.32805L55.7928 6.49962L52.9645 3.67128L53.6716 2.96417L56.4999 5.79252Z"
                        fill="#6E7882"
                    />
                    <rect
                        x="0.25"
                        y="6.25"
                        width="7.5"
                        height="0.5"
                        stroke="#6E7882"
                        stroke-width="0.5"
                    />
                </svg>
                <div class="qy-wechat-right-head-content">
                    <div class="qy-wechat-right-head-content-mame">
                        {{ config.app_name }}
                    </div>
                    <div class="qy-wechat-right-head-content-menu">
                        <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                x="0.5"
                                y="0.5"
                                width="5"
                                height="5"
                                stroke="#6E7882"
                            />
                            <rect
                                x="0.5"
                                y="8.5"
                                width="5"
                                height="5"
                                stroke="#6E7882"
                            />
                            <rect
                                x="8.5"
                                y="0.5"
                                width="5"
                                height="5"
                                stroke="#6E7882"
                            />
                            <rect
                                x="8.25"
                                y="9.25"
                                width="5.5"
                                height="0.5"
                                stroke="#6E7882"
                                stroke-width="0.5"
                            />
                            <rect
                                x="8.25"
                                y="12.25"
                                width="5.5"
                                height="0.5"
                                stroke="#6E7882"
                                stroke-width="0.5"
                            />
                        </svg>
                    </div>
                </div>
            </div>
            <div class="qy-wechat-right-content">
                <div
                    v-if="isExpertWorkbench"
                    class="qy-wechat-right-content-message"
                >
                    {{ message }}请点击<a href="javascript:void(0);">此处</a>进行接待。
                </div>
            </div>
            <div class="qy-wechat-right-menu">
                <svg
                    width="320"
                    height="1"
                    viewBox="0 0 320 1"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        x="320"
                        width="1"
                        height="320"
                        transform="rotate(90 320 0)"
                        fill="#E6E8EB"
                    />
                </svg>
                <div class="qy-wechat-right-menu-content">
                    <div class="qy-wechat-right-menu-content-bar">
                        <div
                            v-if="isExpertWorkbench"
                            class="qy-wechat-right-menu-content-bar-item"
                        >
                            进入接待
                        </div>
                        <div
                            v-else-if="config.tmpl_type === 2"
                            class="qy-wechat-right-menu-content-bar-item web-consult"
                        >
                            网页咨询
                            <div class="guide-img">
                                <div class="guide-arrow">
                                    <svg
                                        width="24"
                                        class="circle-big"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            opacity="0.3"
                                            cx="12"
                                            cy="12"
                                            r="12"
                                            fill="#00D48A"
                                        />
                                    </svg>
                                    <svg
                                        width="12"
                                        class="circle-small"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="6"
                                            cy="6"
                                            r="6"
                                            fill="#00D48A"
                                        />
                                    </svg>
                                    <svg
                                        width="16"
                                        class="arrow"
                                        height="51"
                                        viewBox="0 0 16 51"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M7.29289 50.7071C7.68342 51.0976 8.31658 51.0976 8.70711 50.7071L15.0711 44.3431C15.4616 43.9526 15.4616 43.3195 15.0711 42.9289C14.6805 42.5384 14.0474 42.5384 13.6569 42.9289L8 48.5858L2.34315 42.9289C1.95262 42.5384 1.31946 42.5384 0.928932 42.9289C0.538408 43.3195 0.538408 43.9526 0.928932 44.3431L7.29289 50.7071ZM7 0L7 50H9L9 0L7 0Z"
                                            fill="#00D48A"
                                        />
                                    </svg>
                                    <p class="guide-text">
                                        访客点击后用浏览器打开网页咨询窗口
                                    </p>
                                </div>
                                <div class="guide-pic">
                                    <svg
                                        class="guide-pic-wrapper"
                                        width="560"
                                        height="340"
                                        viewBox="0 0 560 340"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M0 3C0 1.34315 1.34315 0 3 0H557.5C558.881 0 560 1.11929 560 2.5V32.9412H0V3Z"
                                            fill="#E1E6F0"
                                        />
                                        <path
                                            opacity="0.6"
                                            d="M0.75 5.96161C0.75 4.90585 0.750583 4.15914 0.798273 3.57545C0.845247 3.00051 0.93416 2.65009 1.07436 2.37492C1.35968 1.81495 1.81495 1.35968 2.37492 1.07436C2.65009 0.93416 3.00051 0.845247 3.57544 0.798273C4.15914 0.750583 4.90585 0.75 5.9616 0.75H554.038C555.094 0.75 555.841 0.750583 556.425 0.798273C557 0.845247 557.35 0.934161 557.625 1.07436C558.185 1.35969 558.64 1.81496 558.926 2.37494C559.066 2.65007 559.155 3.00049 559.202 3.57544C559.249 4.15913 559.25 4.90585 559.25 5.9616V334.038C559.25 335.094 559.249 335.841 559.202 336.425C559.155 336.999 559.066 337.35 558.926 337.625C558.64 338.185 558.185 338.64 557.625 338.926C557.35 339.066 557 339.155 556.425 339.202C555.841 339.249 555.094 339.25 554.038 339.25H5.96162C4.90586 339.25 4.15915 339.249 3.57545 339.202C3.00051 339.155 2.6501 339.066 2.37494 338.926L2.03494 339.593L2.37491 338.926C1.81495 338.64 1.35969 338.185 1.07437 337.625C0.93416 337.35 0.845247 336.999 0.798273 336.425C0.750583 335.841 0.75 335.094 0.75 334.038V5.96161Z"
                                            stroke="#D8DFED"
                                            stroke-width="1.5"
                                        />
                                        <circle
                                            cx="17.9678"
                                            cy="16.4706"
                                            r="4.49198"
                                            fill="white"
                                        />
                                        <circle
                                            cx="32.9412"
                                            cy="16.4706"
                                            r="4.49198"
                                            fill="white"
                                        />
                                        <circle
                                            cx="47.9143"
                                            cy="16.4706"
                                            r="4.49198"
                                            fill="white"
                                        />
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M67 13.6575C67 11.0852 69.0852 9 71.6575 9H134.342C136.915 9 139 11.0852 139 13.6575V33H67V13.6575Z"
                                            fill="white"
                                        />
                                    </svg>
                                    <svg
                                        width="344"
                                        class="guide-pic-inner"
                                        height="267"
                                        viewBox="0 0 344 267"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g filter="url(#filter0_d)">
                                            <rect
                                                x="10.3885"
                                                y="10"
                                                width="322.963"
                                                height="246.428"
                                                rx="4"
                                                fill="white"
                                            />
                                        </g>
                                        <path
                                            d="M20.9565 20.3194H21.9405V24.0394H26.8965V20.3194H27.8805V28.8874H26.8965V24.8914H21.9405V28.8874H20.9565V20.3194ZM29.5932 20.3194H33.2892C34.1452 20.3194 34.8172 20.5154 35.3052 20.9074C35.8172 21.3234 36.0732 21.9234 36.0732 22.7074C36.0732 23.1794 35.9412 23.6034 35.6772 23.9794C35.3972 24.3554 35.0092 24.6034 34.5132 24.7234V24.7474C35.3292 24.9314 35.7852 25.4514 35.8812 26.3074L36.0132 27.6274C36.0612 28.1474 36.2132 28.5674 36.4692 28.8874H35.4012C35.2012 28.5914 35.0852 28.2114 35.0532 27.7474L34.9452 26.6074C34.8972 26.0954 34.7172 25.7314 34.4052 25.5154C34.1252 25.3074 33.7132 25.2034 33.1692 25.2034H30.5772V28.8874H29.5932V20.3194ZM30.5772 21.1714V24.3514H33.1692C33.7932 24.3514 34.2772 24.2034 34.6212 23.9074C34.9252 23.6274 35.0772 23.2394 35.0772 22.7434C35.0772 22.2154 34.9292 21.8234 34.6332 21.5674C34.3212 21.3034 33.8332 21.1714 33.1692 21.1714H30.5772ZM39.0226 23.1874V25.1914H40.9546V23.1874H39.0226ZM40.9546 22.4074V20.3794H39.0226V22.4074H40.9546ZM39.0106 25.9714C38.9386 27.6434 38.6546 29.0234 38.1586 30.1114L37.5106 29.5114C37.9826 28.4394 38.2266 27.0554 38.2426 25.3594V19.5994H41.7466V28.9474C41.7466 29.6834 41.4106 30.0514 40.7386 30.0514H39.7786L39.5746 29.2834C40.0226 29.3154 40.3306 29.3314 40.4986 29.3314C40.8026 29.3314 40.9546 29.1114 40.9546 28.6714V25.9714H39.0106ZM43.5706 24.7834V30.0994H42.7546V19.5874H47.6146C47.6146 21.0754 47.5426 22.0594 47.3986 22.5394C47.2546 23.0354 46.8066 23.2834 46.0546 23.2834H45.0826L44.8546 22.5394L45.6586 22.5514C45.9226 22.5514 46.1346 22.5314 46.2946 22.4914C46.4386 22.4434 46.5466 22.3274 46.6186 22.1434C46.6986 21.8954 46.7506 21.3074 46.7746 20.3794H43.5706V24.0154H47.6506V24.7474C47.4266 25.9794 47.0346 27.0314 46.4746 27.9034C47.0026 28.4234 47.6386 28.8954 48.3826 29.3194L47.9506 30.0514C47.1986 29.6194 46.5426 29.1274 45.9826 28.5754C45.4546 29.1914 44.8346 29.6874 44.1226 30.0634L43.6666 29.3674C44.3466 28.9994 44.9266 28.5274 45.4066 27.9514C44.6386 27.0154 44.1226 25.9594 43.8586 24.7834H43.5706ZM44.6026 24.7834C44.8506 25.7034 45.2826 26.5354 45.8986 27.2794C46.3386 26.5674 46.6666 25.7354 46.8826 24.7834H44.6026ZM53.8426 19.1674C53.7226 19.4554 53.5706 19.7594 53.3866 20.0794H58.6186V20.7754C57.8506 21.6634 56.9146 22.4194 55.8106 23.0434C57.1706 23.6194 58.6826 23.9914 60.3466 24.1594L59.9506 24.9634C58.0546 24.7474 56.3626 24.2674 54.8746 23.5234C53.4026 24.2034 51.6946 24.6914 49.7506 24.9874L49.3546 24.1714C51.0906 23.9314 52.6186 23.5474 53.9386 23.0194C53.2826 22.6354 52.6586 22.1834 52.0666 21.6634C51.5946 22.0874 51.0946 22.4594 50.5666 22.7794L50.0386 22.0834C51.4946 21.2514 52.4706 20.2394 52.9666 19.0474L53.8426 19.1674ZM54.8626 22.5994C55.8146 22.1274 56.6546 21.5594 57.3826 20.8954H52.7986L52.6426 21.0874C53.3066 21.6714 54.0466 22.1754 54.8626 22.5994ZM54.9826 24.3874C54.9826 24.8194 54.9426 25.2754 54.8626 25.7554H59.0866C59.0626 27.7874 58.8786 28.9994 58.5346 29.3914C58.1826 29.7914 57.5826 29.9914 56.7346 29.9914C56.5346 29.9914 56.0666 29.9754 55.3306 29.9434L55.1146 29.1634L56.5306 29.2234C57.2426 29.2154 57.6946 29.0634 57.8866 28.7674C58.0706 28.4794 58.1786 27.7354 58.2106 26.5354H54.6586C54.5706 26.8314 54.4426 27.1314 54.2746 27.4354C53.6586 28.5234 52.2506 29.4154 50.0506 30.1114L49.4746 29.4034C51.4506 28.8274 52.7506 28.0994 53.3746 27.2194C53.5426 26.9714 53.6666 26.7434 53.7466 26.5354H50.1706V25.7554H53.9866C54.0826 25.3234 54.1306 24.8674 54.1306 24.3874H54.9826ZM66.2626 19.7794V27.1234L67.0426 26.8714V27.6994C65.4426 28.2674 63.6346 28.7754 61.6186 29.2234L61.3786 28.3954L62.2066 28.2154V19.7794H66.2626ZM63.0826 28.0114C63.9626 27.7954 64.7346 27.5874 65.3986 27.3874V25.8034H63.0826V28.0114ZM63.0826 25.0234H65.3986V23.1634H63.0826V25.0234ZM63.0826 22.3834H65.3986V20.5714H63.0826V22.3834ZM68.3626 19.1434H69.2506V21.3634H71.9146C71.9146 25.2114 71.8546 27.5914 71.7346 28.5034C71.5986 29.4794 70.9626 29.9674 69.8266 29.9674C69.6506 29.9674 69.3506 29.9554 68.9266 29.9314L68.7226 29.1634C69.2346 29.1954 69.5626 29.2114 69.7066 29.2114C70.3946 29.2114 70.7946 28.8674 70.9066 28.1794C70.9786 27.5314 71.0266 25.5314 71.0506 22.1794H69.2506V22.2874C69.2186 25.8634 68.3746 28.4834 66.7186 30.1474L66.0346 29.5354C67.5626 28.0314 68.3386 25.6154 68.3626 22.2874V22.1794H66.9106V21.3634H68.3626V19.1434ZM83.2906 19.9234C82.1466 20.2274 80.8826 20.4474 79.4986 20.5834V22.6114H83.3266V23.4514H79.4986V25.4194H84.2266V26.2474H79.4986V28.8994C79.4986 29.6274 79.1226 29.9914 78.3706 29.9914H76.5106L76.3186 29.1514C77.1346 29.1834 77.7186 29.1994 78.0706 29.1994C78.4386 29.1994 78.6226 29.0274 78.6226 28.6834V26.2474H73.4626V25.4194H78.6226V23.4514H74.4586V22.6114H78.6226V20.6554C77.2466 20.7594 75.8666 20.8114 74.4826 20.8114L74.2186 20.0314C77.6586 20.0314 80.5426 19.7514 82.8706 19.1914L83.2906 19.9234Z"
                                            fill="black"
                                        />
                                        <path
                                            d="M242.321 10H329.437C331.646 10 333.437 11.7909 333.437 14V252.428C333.437 254.637 331.646 256.428 329.437 256.428H242.321V10Z"
                                            fill="#F3F5FA"
                                        />
                                        <line
                                            x1="10"
                                            y1="203.783"
                                            x2="242.13"
                                            y2="203.783"
                                            stroke="#F3F5FA"
                                        />
                                        <line
                                            x1="10.3884"
                                            y1="38.0319"
                                            x2="242.32"
                                            y2="38.0319"
                                            stroke="#F3F5FA"
                                        />
                                        <path
                                            d="M26.7997 90.0354C26.7997 88.9308 27.6951 88.0354 28.7997 88.0354H164.442C165.547 88.0354 166.442 88.9308 166.442 90.0354V139.428C166.442 140.533 165.547 141.428 164.442 141.428H28.7997C27.6951 141.428 26.7997 140.533 26.7997 139.428V90.0354Z"
                                            fill="#F3F5FA"
                                        />
                                        <rect
                                            x="39.3801"
                                            y="101.116"
                                            width="26.9207"
                                            height="26.9207"
                                            fill="white"
                                        />
                                        <rect
                                            x="74.0321"
                                            y="102.41"
                                            width="55.4462"
                                            height="8.21425"
                                            fill="white"
                                        />
                                        <rect
                                            x="74.0321"
                                            y="116.785"
                                            width="75.9818"
                                            height="8.21425"
                                            fill="white"
                                        />
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M220.577 51.4164H229.896L225.754 56.2488V72.1954C225.754 73.3 224.859 74.1954 223.754 74.1954H136.638C135.533 74.1954 134.638 73.3 134.638 72.1954V53.4164C134.638 52.3118 135.533 51.4164 136.638 51.4164H220.577L220.577 51.4164Z"
                                            fill="#9CB8FF"
                                        />
                                        <rect
                                            x="192.621"
                                            y="233.649"
                                            width="39.3456"
                                            height="14.4957"
                                            rx="1"
                                            fill="#9CB8FF"
                                        />
                                        <circle
                                            cx="287.878"
                                            cy="63.8413"
                                            r="24.8498"
                                            fill="white"
                                        />
                                        <rect
                                            x="254.745"
                                            y="101.116"
                                            width="66.2663"
                                            height="8.28328"
                                            fill="white"
                                        />
                                        <rect
                                            x="267.17"
                                            y="117.683"
                                            width="41.4164"
                                            height="8.28328"
                                            fill="white"
                                        />
                                        <defs>
                                            <filter
                                                id="filter0_d"
                                                x="0.38855"
                                                y="0"
                                                width="342.963"
                                                height="266.428"
                                                filterUnits="userSpaceOnUse"
                                                color-interpolation-filters="sRGB"
                                            >
                                                <feFlood
                                                    flood-opacity="0"
                                                    result="BackgroundImageFix"
                                                />
                                                <feColorMatrix
                                                    in="SourceAlpha"
                                                    type="matrix"
                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                    result="hardAlpha"
                                                />
                                                <feOffset />
                                                <feGaussianBlur stdDeviation="5" />
                                                <feColorMatrix
                                                    type="matrix"
                                                    values="0 0 0 0 0.150708 0 0 0 0 0.175301 0 0 0 0 0.239244 0 0 0 0.15 0"
                                                />
                                                <feBlend
                                                    mode="normal"
                                                    in2="BackgroundImageFix"
                                                    result="effect1_dropShadow"
                                                />
                                                <feBlend
                                                    mode="normal"
                                                    in="SourceGraphic"
                                                    in2="effect1_dropShadow"
                                                    result="shape"
                                                />
                                            </filter>
                                        </defs>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="qy-wechat-right-menu-content-bar-item">
                            我的工单
                        </div>
                    </div>
                    <svg
                        width="49"
                        height="32"
                        viewBox="0 0 50 32"
                        class="qy-wechat-right-menu-toggle"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            width="50"
                            height="32"
                            fill="#fff"
                        />
                        <svg
                            width="18"
                            height="10"
                            x="16"
                            y="11"
                            viewBox="0 0 18 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                x="5.29492"
                                width="12.7059"
                                height="1.11111"
                                fill="#6E7882"
                            />
                            <rect
                                x="5.29492"
                                y="4.44434"
                                width="12.7059"
                                height="1.11111"
                                fill="#6E7882"
                            />
                            <path
                                d="M3.17647 2.22266V7.77821L0 5.00043L3.17647 2.22266Z"
                                fill="#6E7882"
                            />
                            <rect
                                x="5.29492"
                                y="8.88867"
                                width="12.7059"
                                height="1.11111"
                                fill="#6E7882"
                            />
                        </svg>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable max-len */
export default {
    props: {
        config: {
            type: Object,
            default() {
                return {};
            },
        },
        isExpertWorkbench: {
            type: Boolean,
            default: false,
        },
        message: {
            type: String,
            default: '一条新消息',
        },
    },
    data() {
        return {
            iserror: false,
        };
    },
    methods: {
        getIcon(data) {
            let href = data;
            if (this.iserror) {
                href = 'https://wework.qpic.cn/bizmail/2VCMmdZ7hJpN6myyjicpduc2jzuCCGrDcEOC3rXib5icZRY2dOACv0nnA/0';
            }
            return href;
        },
    },
};
</script>

<style lang="less">
.qy-wechat {
    display: flex;
    line-height: 0;
    padding: 20px;
    background: var(--color-fill-hover);
    border-radius: 4px;
    a {
        color: #0067ed;
    }
    &-main {
    }
    &-right {
        width: 320px;
        position: relative;
        background: #fff;


        &-head {
            padding: 6px 15px;
            text-align: right;
            border-bottom: 1px solid #e6e8eb;
            &-content {
                display: flex;
                justify-content: space-between;
                line-height: 22px;
                margin-top: 6px;
            }
        }
        &-content {
            padding: 20px;
            font-size: 12px;
            line-height: 17px;
            overflow: auto;
            max-height: 243px;
            &-message {
                padding: 10px;
                width: 280px;
                background: #dee0e3;
                border-radius: 3px;
                box-sizing: border-box;
                word-break: break-all;
            }
        }
        &-menu {
            position: absolute;
            bottom: 0;
            left: 0;
            &-content {
                display: flex;
                &-bar {
                    display: flex;
                    flex: auto;
                    line-height: 32px;
                    background: #fff;
                    &-item {
                        flex: auto;
                        text-align: center;
                        border-right: 1px solid #e6e8eb;
                        &.web-consult {
                            position: relative;
                            .guide-img {
                                .guide-arrow {
                                    position: absolute;
                                    right: 8px;
                                    top: 4px;
                                    .circle-big {
                                        position: absolute;
                                        right: 0;
                                        top: 0;
                                    }
                                    .circle-small {
                                        position: absolute;
                                        right: 6px;
                                        top: 6px;
                                    }
                                    .arrow {
                                        position: absolute;
                                        right: 4px;
                                        top: 12px;
                                    }
                                    .guide-text {
                                        position: absolute;
                                        width: 221px;
                                        height: 17px;
                                        right: 24px;
                                        top: 50px;
                                        font-style: normal;
                                        font-weight: 500;
                                        font-size: 13px;
                                        line-height: 17px;
                                        color: #00d48a;
                                    }
                                }
                                .guide-pic {
                                    position: absolute;
                                    top: 75px;
                                    left: -260px;
                                    width: 600px;
                                    height: 380px;
                                    box-sizing: border-box;
                                    padding: 20px;
                                    background: var(--color-fill-hover);
                                    border-radius: 4px;
                                    .guide-pic-wrapper {
                                        position: absolute;
                                        top: 0;
                                        margin: 20px 0 0 20px;
                                        left: 0;
                                        background: #fff;
                                        border-radius: 4px;
                                    }
                                    .guide-pic-inner {
                                        position: absolute;
                                        top: 60px;
                                        left: 110px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            &-toggle {
                // cursor: pointer;
            }
        }
    }
}
</style>
